import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data;

const getDays = createSelector(getState, ({ days }) => days);
export default {
  getDays,
};
